import React from 'react';
import Equalizer from 'react-equalizer';

export default props => {
    const { showStickyItemsClasses, toggleExpandedNav, navClasses, listMarkup, wrapperId, navId, colouroptions, showExpandedNav } = props;

    const renderDefaultNav = () => {
        return (
            <div className="sticky-nav-inner" data-smart-affix="true" id={wrapperId}>
                <div className={showStickyItemsClasses} onClick={toggleExpandedNav} tabIndex={0} role="button">
                    <button>
                        <span className="bar" />
                        <span className="bar" />
                        <span className="bar" />
                    </button>
                </div>
                <div className="container">
                    <Equalizer className="col-md-12" id={navId}>
                        <ul className={navClasses}>{listMarkup}</ul>
                    </Equalizer>
                </div>
            </div>
        );
    }

    const renderColoredNav = (navType) => {
        return (
            <div className={`sustainability-container-${navType}`} data-smart-affix="true" id={wrapperId}>
                <div className={`${navType}-sticky-nav-inner`}>
                    <div className={showStickyItemsClasses}>
                        <div className="sticky-nav-flex-container">
                            <div className="header-row">
                                <button
                                    onClick={toggleExpandedNav}
                                    data-testid="expand-nav"
                                    aria-label="Toggle menu"
                                    aria-expanded={showExpandedNav ? 'true' : 'false'}
                                    aria-controls={`nav-list-${wrapperId}`}
                                >
                                    <span className="bar" />
                                    <span className="bar" />
                                    <span className="bar" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`container tw-px-0 ${showExpandedNav ? 'show-list' : 'show-list'}`}
                        aria-hidden={showExpandedNav ? 'false' : 'true'}
                    >
                        <Equalizer id={navId}>
                            <ul className={`${navClasses} nav-container`}>
                                {listMarkup}
                            </ul>
                        </Equalizer>
                    </div>
                </div>
            </div>
        );
    }

    const renderNav = () => {
        if (colouroptions === 'Light Green') {
            return renderColoredNav('green');
        } else if (colouroptions === 'Light Blue') {
            return renderColoredNav('blue');
        } else {
            return renderDefaultNav();
        }
    }

    return renderNav();
};
